"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelAction = exports.applyAction = exports.initModal = void 0;
exports.closeModal = closeModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = __importDefault(require("react-dom/client"));
const App_1 = require("./App");
const textUtil_1 = require("./common/textUtil");
const adminApiUtil_1 = require("./common/adminApiUtil");
// Store the React root globally to avoid remounting
let modalRoot = null;
const initModal = (action) => {
    // Find the modal container
    const modalContainer = document.querySelector('[data-wpj-modal-mount]');
    if (!modalContainer) {
        console.error('Modal container with [data-wpj-modal-mount] not found.');
        return;
    }
    // Create a root if it doesn't exist
    if (!modalRoot) {
        modalRoot = client_1.default.createRoot(modalContainer);
    }
    const dataAttr = modalContainer.getAttribute('data-wpj-modal-mount');
    const displayStyle = (dataAttr ? dataAttr : 'modal');
    // Render modal with updated data
    modalRoot.render(
    // <React.StrictMode>
    (0, jsx_runtime_1.jsx)(App_1.App, { close: closeModal, llmAction: action, displayStyle: displayStyle }));
};
exports.initModal = initModal;
let applyGlobalAbort = null;
const applyAction = (action, buttonId) => {
    const body = Object.assign(Object.assign({}, action), { text: (0, textUtil_1.getTargetText)(action.target) });
    const buttonEl = document.getElementById(buttonId !== null && buttonId !== void 0 ? buttonId : '');
    buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.classList.add('is-submitting');
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    applyGlobalAbort && applyGlobalAbort('applyUser');
    applyGlobalAbort = null;
    let result = '';
    // throttle update interval, because ckeditor behaves weirdly when update interval is too fast
    let updateInterval = null;
    updateInterval =
        (0, textUtil_1.isTargetCkeditor)(action.target) &&
            setInterval(() => {
                (0, textUtil_1.setTargetText)(action.target, result);
            }, 700);
    const request = (0, adminApiUtil_1.getPromptStreamResponse)(body, (partialResponse) => {
        result = partialResponse;
        !(0, textUtil_1.isTargetCkeditor)(action.target) && (0, textUtil_1.setTargetText)(action.target, result);
    });
    applyGlobalAbort = request.abort;
    request.promise
        .then(() => {
        (0, textUtil_1.setTargetText)(action.target, result);
        buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.classList.remove('is-submitting');
    })
        .catch((reason) => {
        if (reason instanceof adminApiUtil_1.LlmResponseError) {
            alert(reason.message);
        }
        if (reason !== 'applyUser') {
            buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.classList.remove('is-submitting');
        }
    })
        .finally(() => {
        updateInterval && clearInterval(updateInterval);
    });
};
exports.applyAction = applyAction;
const cancelAction = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    applyGlobalAbort && applyGlobalAbort();
    applyGlobalAbort = null;
};
exports.cancelAction = cancelAction;
function closeModal() {
    if (modalRoot) {
        modalRoot.unmount();
        modalRoot = null;
        window.parent.postMessage({
            event: 'llm-modal-closed',
        });
    }
}
